import type { RouteObject } from "react-router";

/** `/positions` — the operator's own positions in every token (contract §12). */
export const positionsRoutes: RouteObject[] = [
  { path: "positions", lazy: async () => ({ Component: (await import("./PositionsView")).default }) },
];
